import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LogRequestResponseData {
	request_data: any;
	response_data: any;
	orderno?: string;
	created_at?: string;
	message?: string;
}

@Component({
	selector: 'app-log-request-response-modal',
	templateUrl: './log-request-response-modal.component.html',
	styleUrls: ['./log-request-response-modal.component.scss']
})
export class LogRequestResponseModalComponent {
	requestJson: string;
	responseJson: string;

	constructor(
		public dialogRef: MatDialogRef<LogRequestResponseModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LogRequestResponseData
	) {
		this.requestJson = data.request_data != null
			? JSON.stringify(data.request_data, null, 2)
			: '';
		this.responseJson = data.response_data != null
			? JSON.stringify(data.response_data, null, 2)
			: '';
	}

	close(): void {
		this.dialogRef.close();
	}
}
